import React from 'react';
import styled, { keyframes } from 'styled-components';

interface SpinnerProps {
  size?: number;
  color?: string;
  thickness?: number;
}

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerCircle = styled.div<SpinnerProps>`
  width: ${props => props.size || 40}px;
  height: ${props => props.size || 40}px;
  border: ${props => props.thickness || 3}px solid #f3f4f6;
  border-top: ${props => props.thickness || 3}px solid ${props => props.color || '#000000'};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 48px;
`;

const Spinner: React.FC<SpinnerProps> = ({ size, color, thickness }) => {
  return (
    <SpinnerContainer>
      <SpinnerCircle size={size} color={color} thickness={thickness} />
    </SpinnerContainer>
  );
};

export default Spinner;
